module.exports = __webpack_public_path__ + "会议培训.png?0806c1daa3b0a66c83355a8f14ed0ec7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/会议培训.png
// module id = 637
// module chunks = 0